import { createIcon } from '@chakra-ui/react'

export const Home = createIcon({
  displayName: 'Home',
  viewBox: '0 0 20 17',
  d:
    'M10 2.69L15 7.19V15H13V9H7V15H5V7.19L10 2.69ZM10 0L0 9H3V17H9V11H11V17H17V9H20L10 0Z',
})
